import { attachPropertiesToComponent } from '@code/utils';
import { Dialog } from "./Dialog";
import { Footer } from "./Footer";
import { Panel } from "./Panel";
import { useDialog } from "./useDialog";
export default attachPropertiesToComponent(Dialog, {
  Panel: Panel,
  Footer: Footer,
  useDialog: useDialog
});